import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environments/environment';


@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  private notificationsSubject = new Subject<{ message: string }>();
  notifications = this.notificationsSubject.asObservable();
  
  private refreshNotificationsSubject = new Subject<void>();
  refreshNotifications$ = this.refreshNotificationsSubject.asObservable();
  
  private baseUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  addNotification(message: string): void {
    this.notificationsSubject.next({ message });
  }

  triggerNotificationRefresh(): void {
    this.refreshNotificationsSubject.next();
  }

  getEmployeesWithoutFeedback(employeeId: string): Observable<any> {
    return this.http.get(`${this.baseUrl}/hiring/employees-without-feedback/${employeeId}`);
  }
}